module.exports = __webpack_public_path__ + "static/pic04-05b4610c80415bf72a8562fb9808b655.jpg";